module.exports = __webpack_public_path__ + "static/media/cert_66.5cdc6da9.jpg";